import React from "react";
import Timeline from "../components/timeline";
import Footer from "../components/footer";

function History() {
  return (
    <>
      <Timeline />
      <Footer />
    </>
  );
}

export default History;
